"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantInfoStep = TenantInfoStep;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var edit_classification_dialog_1 = require("../../../../components/dialogs/edit-classification-dialog");
var message_1 = require("../../../../components/dialogs/message");
var tenant_1 = require("../../../../features/apis/tenant");
var save_shortcut_1 = require("../../../../features/save-shortcut/save-shortcut");
var message_dialog_1 = require("../../../../features/thunks/message-dialog");
var hooks_1 = require("../../../../store/hooks");
var change_diff_1 = require("../../../../utils/change-diff");
var tenant_field_meta_1 = require("../tenant-field-meta");
var utilityOptions = ["Power", "Water"];
function buildInitialFormData(existing) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (existing) {
        return {
            name: existing.name || "",
            partyType: existing.partyType || "Tenant",
            registrationNumber: existing.registrationNumber || "",
            taxNumber: existing.taxNumber || "",
            tenantCode: existing.tenantCode || "",
            isJuristicPerson: (_a = existing.isJuristicPerson) !== null && _a !== void 0 ? _a : true,
            tradingAsName: existing.tradingAsName || "",
            accountCode: existing.accountCode || "",
            sameAccountCodeAllBuildings: (_b = existing.sameAccountCodeAllBuildings) !== null && _b !== void 0 ? _b : true,
            taxType: existing.taxType || "Standard Rate Sales (15%)",
            isActive: (_c = existing.isActive) !== null && _c !== void 0 ? _c : true,
            address: {
                line1: ((_d = existing.address) === null || _d === void 0 ? void 0 : _d.line1) || "",
                line2: ((_e = existing.address) === null || _e === void 0 ? void 0 : _e.line2) || "",
                city: ((_f = existing.address) === null || _f === void 0 ? void 0 : _f.city) || "",
                region: ((_g = existing.address) === null || _g === void 0 ? void 0 : _g.region) || "",
                postalCode: ((_h = existing.address) === null || _h === void 0 ? void 0 : _h.postalCode) || "",
                country: ((_j = existing.address) === null || _j === void 0 ? void 0 : _j.country) || "South Africa",
            },
            contactPersons: existing.contactPersons && existing.contactPersons.length > 0
                ? existing.contactPersons
                : existing.contactDetails
                    ? [
                        {
                            name: "",
                            email: existing.contactDetails.email || "",
                            phone: existing.contactDetails.phone || "",
                            utilities: existing.contactDetails.utilities || [],
                            priority: 1,
                        },
                    ]
                    : [],
            billingContacts: existing.billingContacts && existing.billingContacts.length > 0
                ? existing.billingContacts
                : existing.billingContact
                    ? [
                        {
                            name: existing.billingContact.name || "",
                            email: existing.billingContact.email || "",
                            phone: existing.billingContact.phone || "",
                            utilities: existing.billingContact.utilities || [],
                            priority: 1,
                        },
                    ]
                    : [],
        };
    }
    return {
        name: "",
        partyType: "Tenant",
        registrationNumber: "",
        taxNumber: "",
        tenantCode: "",
        isJuristicPerson: true,
        tradingAsName: "",
        accountCode: "",
        sameAccountCodeAllBuildings: true,
        taxType: "Standard Rate Sales (15%)",
        isActive: true,
        address: { line1: "", line2: "", city: "", region: "", postalCode: "", country: "South Africa" },
        contactPersons: [],
        billingContacts: [],
    };
}
function ContactPersonsEditor(props) {
    var contacts = props.contacts, onChange = props.onChange, isDisabled = props.isDisabled, title = props.title;
    var addContact = function () {
        onChange(__spreadArray(__spreadArray([], contacts, true), [{ name: "", email: "", phone: "", utilities: [], priority: contacts.length + 1 }], false));
    };
    var removeContact = function (idx) {
        var updated = contacts.filter(function (_, i) { return i !== idx; }).map(function (c, i) { return (__assign(__assign({}, c), { priority: i + 1 })); });
        onChange(updated);
    };
    var moveUp = function (idx) {
        var _a;
        if (idx === 0)
            return;
        var updated = __spreadArray([], contacts, true);
        _a = [updated[idx], updated[idx - 1]], updated[idx - 1] = _a[0], updated[idx] = _a[1];
        onChange(updated.map(function (c, i) { return (__assign(__assign({}, c), { priority: i + 1 })); }));
    };
    var moveDown = function (idx) {
        var _a;
        if (idx === contacts.length - 1)
            return;
        var updated = __spreadArray([], contacts, true);
        _a = [updated[idx + 1], updated[idx]], updated[idx] = _a[0], updated[idx + 1] = _a[1];
        onChange(updated.map(function (c, i) { return (__assign(__assign({}, c), { priority: i + 1 })); }));
    };
    var updateField = function (idx, field, value) {
        var updated = contacts.map(function (c, i) {
            var _a;
            return (i === idx ? __assign(__assign({}, c), (_a = {}, _a[field] = value, _a)) : c);
        });
        onChange(updated);
    };
    var toggleUtility = function (idx, utility) {
        var current = contacts[idx].utilities || [];
        var updated = current.includes(utility) ? current.filter(function (u) { return u !== utility; }) : __spreadArray(__spreadArray([], current, true), [utility], false);
        updateField(idx, "utilities", updated);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsx)("h4", { className: "text-sm font-semibold text-gray-700", children: title }), !isDisabled && ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", color: "primary", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:add-circle-linear" }), onPress: addContact, children: "Add Contact" }))] }), contacts.map(function (contact, idx) { return ((0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg border border-gray-200 bg-gray-50/50 p-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-2 flex items-center justify-between", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-xs font-semibold text-primary", children: ["#", idx + 1] }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-1", children: !isDisabled && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", isDisabled: idx === 0, onPress: function () { return moveUp(idx); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:alt-arrow-up-linear", className: "text-sm text-gray-500" }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", isDisabled: idx === contacts.length - 1, onPress: function () { return moveDown(idx); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:alt-arrow-down-linear", className: "text-sm text-gray-500" }) }), contacts.length > 1 && ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", color: "danger", onPress: function () { return removeContact(idx); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:trash-bin-trash-linear", className: "text-sm" }) }))] })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-3", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Name", placeholder: "Contact name", size: "sm", variant: "bordered", value: contact.name, onValueChange: function (v) { return updateField(idx, "name", v); }, isReadOnly: isDisabled }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Email", placeholder: "email@example.com", size: "sm", variant: "bordered", value: contact.email, onValueChange: function (v) { return updateField(idx, "email", v); }, isReadOnly: isDisabled }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Phone", placeholder: "+27 11 555 0000", size: "sm", variant: "bordered", value: contact.phone, onValueChange: function (v) { return updateField(idx, "phone", v); }, isReadOnly: isDisabled })] }), (0, jsx_runtime_1.jsx)("div", { className: "mt-2 flex flex-wrap gap-3", children: utilityOptions.map(function (u) {
                            var _a, _b;
                            return ((0, jsx_runtime_1.jsx)(react_1.Checkbox, { size: "sm", isSelected: (_b = (_a = contact.utilities) === null || _a === void 0 ? void 0 : _a.includes(u)) !== null && _b !== void 0 ? _b : false, onValueChange: function () { return toggleUtility(idx, u); }, isDisabled: isDisabled, children: (0, jsx_runtime_1.jsxs)("span", { className: "text-xs", children: [u, " Invoices"] }) }, u));
                        }) })] }, idx)); })] }));
}
function TenantInfoStep(props) {
    var _this = this;
    var _a;
    var tenantId = props.tenantId, existingTenant = props.existingTenant, mode = props.mode, isCreationFlow = props.isCreationFlow, onSaved = props.onSaved, _b = props.variant, variant = _b === void 0 ? "step" : _b;
    var isEmbedded = variant === "embedded";
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _c.clientId, userId = _c.userId;
    var isViewMode = mode === "view";
    var _d = (0, react_3.useState)(function () { return buildInitialFormData(existingTenant); }), formData = _d[0], setFormData = _d[1];
    /*
     * Re-hydrate when the tenant actually arrives.
     *
     * The `useState` above is a lazy initialiser: it runs ONCE, at mount. That is fine on the edit path,
     * where the page holds a spinner until the fetch resolves — but not on the create path. There, saving
     * the tenant sets `activeTenantId`, which swaps the standalone form for the one inside
     * AreasLeasesStep's `tenantDetailsSlot`. That is a different element position, so React unmounts and
     * REMOUNTS this component, and at that instant `useFetchTenantQuery` has only just fired and
     * `existingTenant` is still undefined. The form initialised blank and, with nothing watching, stayed
     * blank — the details were saved but Tenancy Configuration showed empty fields.
     *
     * Keyed on the tenant's id, not on the object: RTK Query hands back a new reference on every refetch,
     * and re-running this on each of those would wipe whatever the user had typed since. Same id means
     * same tenant, so the form keeps what it has — including immediately after its own save.
     */
    var hydratedTenantIdRef = (0, react_3.useRef)((_a = existingTenant === null || existingTenant === void 0 ? void 0 : existingTenant._id) !== null && _a !== void 0 ? _a : null);
    (0, react_3.useEffect)(function () {
        var _a;
        var id = (_a = existingTenant === null || existingTenant === void 0 ? void 0 : existingTenant._id) !== null && _a !== void 0 ? _a : null;
        if (!id || id === hydratedTenantIdRef.current)
            return;
        hydratedTenantIdRef.current = id;
        setFormData(buildInitialFormData(existingTenant));
    }, [existingTenant]);
    var _e = (0, react_3.useState)(false), isSaving = _e[0], setIsSaving = _e[1];
    var _f = (0, react_3.useState)(false), isClassificationOpen = _f[0], setIsClassificationOpen = _f[1];
    var dispatch = (0, hooks_1.useAppDispatch)();
    var createTenant = (0, tenant_1.useCreateTenantMutation)()[0];
    var updateTenant = (0, tenant_1.useUpdateTenantMutation)()[0];
    var moveTenantLeases = (0, tenant_1.useMoveTenantLeasesMutation)()[0];
    var _g = (0, react_3.useState)(null), movingToTenantId = _g[0], setMovingToTenantId = _g[1];
    /**
     * ATOC-2 §7: move THIS tenant's leases onto the duplicate that owns the identifier.
     *
     * Direction matters and is deliberate: the matched tenant is the survivor. The warning already says
     * "Add the new lease to that tenant instead" and offers "Open tenant", so the record the user is told
     * to continue on is the one that should end up holding everything. The emptied record is deactivated,
     * never deleted — documents already issued may reference it, and an accidental merge has to be
     * reversible by moving the leases back.
     */
    var handleMoveLeases = function (toTenantId, toName) { return __awaiter(_this, void 0, void 0, function () {
        var choice, res, moved, err_1, message;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!tenantId || !clientId || !userId)
                        return [2 /*return*/];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Move leases to this tenant?",
                            body: "Every lease on \"".concat(formData.name, "\" moves to \"").concat(toName, "\", together with its meters, invoice settings and billing history. \"").concat(formData.name, "\" is left with no leases and becomes inactive \u2014 it is not deleted, so this can be undone by moving them back."),
                            buttons: [
                                { type: message_1.EMessageDialogButtonType.CANCEL, label: "Cancel", variant: "light" },
                                { type: message_1.EMessageDialogButtonType.OK, label: "Move leases", variant: "solid" },
                            ],
                        })).unwrap()];
                case 2:
                    choice = _d.sent();
                    if (choice !== message_1.EMessageDialogButtonType.OK)
                        return [2 /*return*/];
                    setMovingToTenantId(toTenantId);
                    return [4 /*yield*/, moveTenantLeases({ clientId: clientId, fromTenantId: tenantId, toTenantId: toTenantId, performedBy: userId }).unwrap()];
                case 3:
                    res = _d.sent();
                    moved = (_b = (_a = res.content) === null || _a === void 0 ? void 0 : _a.leasesMoved) !== null && _b !== void 0 ? _b : 0;
                    (0, react_1.addToast)({
                        title: "Leases moved",
                        description: "".concat(moved, " lease").concat(moved === 1 ? "" : "s", " moved to ").concat(toName, "."),
                        color: "success",
                    });
                    navigate("/dashboard/tenants/".concat(toTenantId));
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _d.sent();
                    message = ((_c = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _c === void 0 ? void 0 : _c.message) || "Could not move the leases.";
                    (0, react_1.addToast)({ title: "Move failed", description: message, color: "danger" });
                    return [3 /*break*/, 6];
                case 5:
                    setMovingToTenantId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    /*
     * ATOC-2 §7: warn before saving, not after. Erik: "If the regstiration/ID number or VAT/Tax number
     * has been used for another tenant, then the user should be warned, and have a link to the tenant
     * for which a match exists."
     *
     * A match that still holds active leases is a real duplicate and the save is refused server-side.
     * A match with none is the same entity returning — informational, and the user should reuse it.
     */
    var checkIdentifiers = (0, tenant_1.useLazyCheckTenantIdentifiersQuery)()[0];
    var _h = (0, react_3.useState)([]), identifierMatches = _h[0], setIdentifierMatches = _h[1];
    (0, react_3.useEffect)(function () {
        var registrationNumber = formData.registrationNumber.trim();
        var taxNumber = formData.taxNumber.trim();
        if (!registrationNumber && !taxNumber) {
            setIdentifierMatches([]);
            return;
        }
        // Debounced: this fires as the user types the number.
        var timer = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var res, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, checkIdentifiers({
                                clientId: clientId,
                                registrationNumber: registrationNumber || undefined,
                                taxNumber: taxNumber || undefined,
                                excludeTenantId: tenantId || undefined,
                            }).unwrap()];
                    case 1:
                        res = _d.sent();
                        setIdentifierMatches((_c = (_b = res.content) === null || _b === void 0 ? void 0 : _b.matches) !== null && _c !== void 0 ? _c : []);
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _d.sent();
                        setIdentifierMatches([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 500);
        return function () { return clearTimeout(timer); };
    }, [formData.registrationNumber, formData.taxNumber, clientId, tenantId, checkIdentifiers]);
    // Snapshot of the form fields relevant to the change-diff, in the same shape.
    // Used to compute the diff vs the DB-original (existingTenant) when the user
    // opens the classification dialog.
    var formSnapshot = (0, react_3.useMemo)(function () {
        return {
            name: formData.name,
            // Carried through untouched: there is no input for it here any more (it lives on the lease), so
            // this only round-trips whatever the tenant already holds rather than nulling it on every save.
            tradingAsName: formData.tradingAsName || null,
            partyType: formData.partyType,
            registrationNumber: formData.registrationNumber,
            taxNumber: formData.taxNumber || null,
            tenantCode: formData.tenantCode,
            isJuristicPerson: formData.isJuristicPerson,
            isActive: formData.isActive,
            address: formData.address,
            accountCode: formData.accountCode,
            sameAccountCodeAllBuildings: formData.sameAccountCodeAllBuildings,
            taxType: formData.taxType,
            contactPersons: formData.contactPersons,
            billingContacts: formData.billingContacts,
        };
    }, [formData]);
    var originalSnapshot = (0, react_3.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!existingTenant)
            return null;
        return {
            name: existingTenant.name,
            tradingAsName: (_a = existingTenant.tradingAsName) !== null && _a !== void 0 ? _a : null,
            partyType: existingTenant.partyType,
            registrationNumber: existingTenant.registrationNumber,
            taxNumber: (_b = existingTenant.taxNumber) !== null && _b !== void 0 ? _b : null,
            tenantCode: existingTenant.tenantCode,
            isJuristicPerson: (_c = existingTenant.isJuristicPerson) !== null && _c !== void 0 ? _c : true,
            isActive: existingTenant.isActive,
            address: existingTenant.address,
            accountCode: existingTenant.accountCode,
            sameAccountCodeAllBuildings: (_d = existingTenant.sameAccountCodeAllBuildings) !== null && _d !== void 0 ? _d : true,
            taxType: existingTenant.taxType,
            contactPersons: (_e = existingTenant.contactPersons) !== null && _e !== void 0 ? _e : [],
            billingContacts: (_f = existingTenant.billingContacts) !== null && _f !== void 0 ? _f : [],
        };
    }, [existingTenant]);
    var pendingChanges = (0, react_3.useMemo)(function () {
        if (!originalSnapshot)
            return [];
        return (0, change_diff_1.computeFieldDiff)(originalSnapshot, formSnapshot, tenant_field_meta_1.TENANT_FIELD_META);
    }, [originalSnapshot, formSnapshot]);
    var set = function (field, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    };
    var setAddress = function (field, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), { address: __assign(__assign({}, prev.address), (_a = {}, _a[field] = value, _a)) }));
        });
    };
    var submitUpdate = function (classification) { return __awaiter(_this, void 0, void 0, function () {
        var payload, res, err_2, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!tenantId)
                        return [2 /*return*/];
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    payload = {
                        _id: tenantId,
                        clientId: clientId,
                        editClassification: classification.classification,
                        effectiveDate: classification.effectiveDate,
                        effectiveTime: classification.effectiveTime,
                        reason: classification.reason,
                        fieldClassifications: classification.fieldClassifications,
                        name: formData.name,
                        partyType: formData.partyType,
                        registrationNumber: formData.registrationNumber,
                        taxNumber: formData.taxNumber || null,
                        tenantCode: formData.tenantCode,
                        isJuristicPerson: formData.isJuristicPerson,
                        // No input for this here any more — round-tripped so an edit on this form cannot null it.
                        tradingAsName: formData.tradingAsName || null,
                        contactPersons: formData.contactPersons,
                        billingContacts: formData.billingContacts,
                        address: formData.address,
                        accountCode: formData.accountCode,
                        sameAccountCodeAllBuildings: formData.sameAccountCodeAllBuildings,
                        taxType: formData.taxType,
                        isActive: formData.isActive,
                        lastModifiedBy: userId,
                    };
                    return [4 /*yield*/, updateTenant(payload).unwrap()];
                case 2:
                    res = _b.sent();
                    if (res.success) {
                        (0, react_1.addToast)({ title: "Saved", description: "Tenant information updated.", color: "success" });
                        onSaved(tenantId);
                    }
                    else {
                        (0, react_1.addToast)({ title: "Error", description: res.message || "Failed to update tenant.", color: "danger" });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _b.sent();
                    message = ((_a = err_2 === null || err_2 === void 0 ? void 0 : err_2.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Error", description: message, color: "danger" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, newId, err_3, message;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!formData.name.trim()) {
                        (0, react_1.addToast)({ title: "Validation", description: "Tenant name is required.", color: "danger" });
                        return [2 /*return*/];
                    }
                    if (!tenantId) return [3 /*break*/, 4];
                    if (!isCreationFlow) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitUpdate({
                            classification: "correction",
                            effectiveDate: null,
                            effectiveTime: null,
                            reason: "Tenant onboarding (initial setup)",
                        })];
                case 1:
                    _d.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (pendingChanges.length === 0) {
                        // Nothing to persist — honour the "Continue" part of the button and advance.
                        onSaved(tenantId);
                    }
                    else {
                        setIsClassificationOpen(true);
                    }
                    _d.label = 3;
                case 3: return [2 /*return*/];
                case 4:
                    // Create branch
                    setIsSaving(true);
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, 8, 9]);
                    return [4 /*yield*/, createTenant({
                            clientId: clientId,
                            name: formData.name,
                            partyType: formData.partyType,
                            registrationNumber: formData.registrationNumber,
                            taxNumber: formData.taxNumber || null,
                            tenantCode: formData.tenantCode,
                            isJuristicPerson: formData.isJuristicPerson,
                            // No input for this here any more — round-tripped so an edit on this form cannot null it.
                            tradingAsName: formData.tradingAsName || null,
                            contactPersons: formData.contactPersons,
                            billingContacts: formData.billingContacts,
                            address: formData.address,
                            accountCode: formData.accountCode,
                            sameAccountCodeAllBuildings: formData.sameAccountCodeAllBuildings,
                            taxType: formData.taxType,
                            createdBy: userId,
                        }).unwrap()];
                case 6:
                    res = _d.sent();
                    if (res.success) {
                        newId = (_b = (_a = res.content) === null || _a === void 0 ? void 0 : _a.tenant) === null || _b === void 0 ? void 0 : _b._id;
                        (0, react_1.addToast)({ title: "Created", description: "Tenant created successfully.", color: "success" });
                        onSaved(newId || "");
                    }
                    else {
                        (0, react_1.addToast)({ title: "Error", description: res.message || "Failed to create tenant.", color: "danger" });
                    }
                    return [3 /*break*/, 9];
                case 7:
                    err_3 = _d.sent();
                    message = ((_c = err_3 === null || err_3 === void 0 ? void 0 : err_3.data) === null || _c === void 0 ? void 0 : _c.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Error", description: message, color: "danger" });
                    return [3 /*break*/, 9];
                case 8:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // ATOC-1 C2.g: Ctrl/Cmd + Shift + S saves this screen.
    (0, save_shortcut_1.useSaveShortcut)({
        label: "Tenant information",
        isEnabled: function () { return !isViewMode; },
        // `pendingChanges` is the same diff the Update-vs-Correction dialog shows, so the prompt and the
        // dialog can never disagree about whether anything changed.
        isDirty: function () { return !isViewMode && pendingChanges.length > 0; },
        handler: handleSave,
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-5 shadow-sm", children: [(0, jsx_runtime_1.jsxs)("h3", { className: "mb-4 flex items-center gap-2 text-sm font-semibold text-gray-700", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:user-id-linear", className: "text-lg text-primary" }), "Tenant Information", (0, jsx_runtime_1.jsx)("span", { className: "text-xs font-normal text-gray-400", children: "The legal entity \u2014 shared across every building it leases in" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: formData.isJuristicPerson ? "Company Name" : "Full Name", placeholder: "e.g. Acme Corp (Pty) Ltd", variant: "bordered", size: "sm", isRequired: !isViewMode, value: formData.name, onValueChange: function (v) { return set("name", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: formData.isJuristicPerson ? "Registration Number" : "ID Number", placeholder: formData.isJuristicPerson ? "e.g. 2020/123456/07" : "e.g. 8001015009087", variant: "bordered", size: "sm", value: formData.registrationNumber, onValueChange: function (v) { return set("registrationNumber", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: formData.isJuristicPerson ? "VAT Number" : "Tax Number", placeholder: "e.g. 4123456789", variant: "bordered", size: "sm", value: formData.taxNumber, onValueChange: function (v) { return set("taxNumber", v); }, isReadOnly: isViewMode })] }), identifierMatches.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "mt-4 flex flex-col gap-2 rounded-lg border p-3 ".concat(identifierMatches.some(function (m) { return m.isBlocking; }) ? "border-danger-200 bg-danger-50/50" : "border-warning-200 bg-warning-50/50"), children: identifierMatches.map(function (m) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center justify-between gap-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-start gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: m.isBlocking ? "solar:danger-triangle-bold" : "solar:info-circle-linear", className: "mt-0.5 ".concat(m.isBlocking ? "text-danger" : "text-warning-600") }), (0, jsx_runtime_1.jsxs)("p", { className: "text-xs text-gray-700", children: ["That ", m.matchedOn.map(function (f) { return (f === "registrationNumber" ? "registration/ID number" : "VAT/tax number"); }).join(" and "), " already belongs to", " ", (0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: m.name }), m.isBlocking
                                                    ? ", which holds ".concat(m.activeLeaseCount, " active lease").concat(m.activeLeaseCount === 1 ? "" : "s", ". Add the new lease to that tenant instead.")
                                                    : " — the same tenant returning. Reuse that record rather than creating a second one."] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-2", children: [tenantId && ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", color: "primary", isLoading: movingToTenantId === m.tenantId, onPress: function () { return handleMoveLeases(m.tenantId, m.name); }, children: "Move leases to this tenant" })), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", onPress: function () { return navigate("/dashboard/tenants/".concat(m.tenantId)); }, children: "Open tenant" })] })] }, m.tenantId)); }) })), (0, jsx_runtime_1.jsx)("div", { className: "mt-4 flex flex-wrap gap-4", children: (0, jsx_runtime_1.jsx)(react_1.Checkbox, { isSelected: formData.isJuristicPerson, onValueChange: function (v) { return set("isJuristicPerson", v); }, isDisabled: isViewMode, size: "md", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: "Tenant is a juristic person" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-500", children: "Tick for companies, CCs, or trusts" })] }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-5 shadow-sm", children: [(0, jsx_runtime_1.jsxs)("h3", { className: "mb-4 flex items-center gap-2 text-sm font-semibold text-gray-700", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:map-point-linear", className: "text-lg text-primary" }), "Address"] }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Address Line 1", variant: "bordered", size: "sm", value: formData.address.line1, onValueChange: function (v) { return setAddress("line1", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Address Line 2", variant: "bordered", size: "sm", value: formData.address.line2, onValueChange: function (v) { return setAddress("line2", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "City", variant: "bordered", size: "sm", value: formData.address.city, onValueChange: function (v) { return setAddress("city", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Region / Province", variant: "bordered", size: "sm", selectedKeys: formData.address.region ? new Set([formData.address.region]) : new Set(), onSelectionChange: function (keys) {
                                    if (keys !== "all")
                                        setAddress("region", Array.from(keys)[0] || "");
                                }, isDisabled: isViewMode, children: ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"].map(function (province) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: province }, province)); }) }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Postal Code", variant: "bordered", size: "sm", value: formData.address.postalCode, onValueChange: function (v) { return setAddress("postalCode", v); }, isReadOnly: isViewMode }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Country", variant: "bordered", size: "sm", value: formData.address.country, onValueChange: function (v) { return setAddress("country", v); }, isReadOnly: isViewMode })] })] }), !isViewMode && ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end gap-2", children: (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", isLoading: isSaving, onPress: handleSave, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:diskette-linear", className: "text-lg" }), children: isEmbedded ? (tenantId ? "Save Tenant Details" : "Create Tenant") : tenantId ? "Save & Continue" : "Create Tenant & Continue" }) })), isViewMode && !isEmbedded && ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end", children: (0, jsx_runtime_1.jsxs)(react_1.Button, { color: "primary", variant: "flat", onPress: function () { return onSaved(tenantId || ""); }, children: ["Next: Areas & Leases", (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-right-linear", className: "ml-1 text-lg" })] }) })), (0, jsx_runtime_1.jsx)(edit_classification_dialog_1.EditClassificationDialog, { isOpen: isClassificationOpen, entityLabel: "Tenant: ".concat(formData.name || (existingTenant === null || existingTenant === void 0 ? void 0 : existingTenant.name) || ""), changes: pendingChanges, onCancel: function () { return setIsClassificationOpen(false); }, onConfirm: function (classification) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsClassificationOpen(false);
                                return [4 /*yield*/, submitUpdate(classification)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } })] }));
}
